<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">Durações</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4" :disabled="task_shared">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-card>
          <v-list two-line subheader :search="search">
            <v-layout>
              <v-flex xs10>
                <v-subheader>Descrição</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader>Ações</v-subheader>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <template v-for="(item, index) in items">
              <v-list-tile :key="index">
                <v-list-tile-content>
                  <!-- moment.duration(moment(props.item.end).diff(props.item.begin)).format('hh [hrs] mm [min] ss [seg]') -->
                  <v-list-tile-title><span style="font-weight:600">{{item.user['id_text'].split(' ').slice(0, 2).join(' ')}}</span><span style="color: gray; font-size:12px;"> - {{moment.duration(moment(item.end).diff(item.begin)).format('hh [hrs] mm [min] ss [seg]')}}</span></v-list-tile-title>
                  <v-list-tile-title>{{ item.begin | formatDateTime }} até {{ item.end | formatDateTime }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.note }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-layout align-center row>
                    <v-tooltip bottom>
                      <v-btn icon slot="activator" class="mx-0" @click="editItem(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id)">
                        <v-icon color="teal">edit</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn icon slot="activator" class="mx-0" @click="dialogDelete(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id)">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                      <span>Deletar</span>
                    </v-tooltip>
                  </v-layout>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="index + 1000" v-if="index + 1 < items.length"></v-divider>
            </template>
            <v-list-tile three-line v-if="items.length === 0">
              {{emptyTable}}
            </v-list-tile>
            <v-divider></v-divider>
            <v-layout align-center fill-height>
              <v-flex xs3>
                <v-subheader>Total</v-subheader>
              </v-flex>
              <v-flex xs9>
                <strong>{{getSum}}</strong>
              </v-flex>
            </v-layout>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="close(400)" @keyup.native.ctrl.enter="save(1, true)" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12 md4>
                  <p-date-time
                    :label="translate('table.' + entity + '.field.begin')"
                    v-model="editedItem.begin"
                    :rules="dateDiffRule(true)"
                  >
                  </p-date-time>
                </v-flex>
                <v-flex xs12 md4>
                  <p-date-time
                    :label="translate('table.' + entity + '.field.end')"
                    v-model="editedItem.end"
                    :rules="dateDiffRule(true)"
                  >
                  </p-date-time>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field readonly="" :label="translate('table.' + entity + '.field.duration')"
                                :value="duration">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field :label="translate('table.' + entity + '.field.note')"
                                v-model="editedItem.note"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save(1, true)">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PDateTime from './../shared/PDateTime'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import PConfirm from './../shared/PConfirm'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [crud, rules],
    components: {
      PDateTime,
      PConfirm
    },
    data: () => ({
      entity: 'task_duration',
      pagination: {
        sortBy: 'begin'
      }
    }),
    name: 'TaskDuration',
    props: {
      task: Object,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      this.items = this.task.durations
      this.$emit('itemsLength', this.items.length)
      this.editedItem = {
        task_id: this.task.id,
        begin: '',
        end: '',
        note: ''
      }
      this.defaultItem = {
        task_id: this.task.id,
        begin: '',
        end: '',
        note: ''
      }
    },
    created () {
      this.pagination.descending = !this.pagination.descending
    },
    methods: {
      afterInsert (item) {
        this.$emit('itemsLength', this.items.length)
        let data = item
        data['type'] = 'add'
        // Manda o evento para recalcular as durações na tela de consulta de tarefas, usado o general pois o recalcular é participar das tarefas
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'durations',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterUpdate (item) {
        let data = item
        data['type'] = 'edit'
        data['old_duration'] = (parseInt(moment(this.beforeEditedItem.end).diff(moment(this.beforeEditedItem.begin))) / 1000)
        // Manda o evento para recalcular as durações na tela de consulta de tarefas, usado o general pois o recalcular é participar das tarefas
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'durations',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      },
      afterDelete (item) {
        this.$emit('itemsLength', this.items.length)
        let data = item
        data['type'] = 'delete'
        // Manda o evento para recalcular as durações na tela de consulta de tarefas, usado o general pois o recalcular é participar das tarefas
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'durations',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
      }
    },
    computed: {
      duration: function () {
        return moment.duration(moment(this.editedItem.end).diff(this.editedItem.begin)).format('hh [hrs] mm [min]')
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text', width: '20%'},
          {text: this.translate('table.' + this.entity + '.field.begin'), value: 'begin', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.end'), value: 'end', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.duration'), value: 'duration', width: '15%'},
          {text: this.translate('table.' + this.entity + '.field.note'), value: 'note', width: '20%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center', width: '15%'}
        ]
      },
      getSum: function () {
        let total = 0
        this.items.forEach(function (value) {
          total = total + moment(value.end).diff(moment(value.begin))
        })
        return moment.duration(total, 'milliseconds').format('hh [hrs] mm [min] ss [sec]')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TaskDuration.vue